"use strict";

var _interopRequireDefault = require("/home/sitc1119/.jenkins/workspace/sitceb-booking-ui-prod/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.function.name");
require("core-js/modules/es7.array.includes");
var _regeneratorRuntime2 = _interopRequireDefault(require("/home/sitc1119/.jenkins/workspace/sitceb-booking-ui-prod/node_modules/@babel/runtime-corejs2/helpers/regeneratorRuntime.js"));
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/home/sitc1119/.jenkins/workspace/sitceb-booking-ui-prod/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
var _objectSpread2 = _interopRequireDefault(require("/home/sitc1119/.jenkins/workspace/sitceb-booking-ui-prod/node_modules/@babel/runtime-corejs2/helpers/objectSpread2.js"));
require("core-js/modules/es6.number.constructor");
var _vuex = require("vuex");
var _DragDialog = _interopRequireDefault(require("@/components/DragDialog"));
var _blExchangeAppointmentSh = require("@/api/blExchangeAppointment/blExchangeAppointmentSh");
var _customerSipg = _interopRequireDefault(require("@/componentsBuz/Associate/customerSipg.vue"));
var _booking = require("@/api/bookSpace/booking");
var _utils = require("@/utils");
var _validate = require("@/utils/validate");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default2 = exports.default = {
  name: "batchReservation",
  components: {
    dragDialog: _DragDialog.default,
    GlCustomerSipg: _customerSipg.default
  },
  props: {
    edoAccreditId: {
      type: String,
      default: ''
    },
    blNos: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    vvLBlNo: {
      type: String,
      default: ''
    },
    amount: {
      type: Number,
      default: 0
    },
    showBtnCancel: {
      type: Boolean,
      default: true
    },
    paymentStatus: {
      type: Number,
      default: 0
    },
    forespeakStatus: {
      type: Number,
      default: 0
    },
    paymentStatusList: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    forespeakStatusList: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    edoPaymentMethod: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    accreditStatusList: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  data: function data() {
    var _this = this;
    return {
      fullscreenSize: false,
      powerAttorney: null,
      acceptList: '.pdf, .jpg, .png, .bmp, .tiff',
      powerAttorneyFileList: [],
      attachmentFileList: [],
      attachmentName: "",
      form: {
        blNos: [],
        forespeakStatus: 0,
        paymentStatus: 0,
        paymentMethod: 1,
        invoiceTitle: "",
        paymentNo: "",
        invoiceTaxNo: "",
        invoiceBankNo: "",
        address: "",
        phone: "",
        accountBank: "",
        receiveEmail: "",
        accreditStatus: 0,
        edoAccreditId: "",
        sipgCustomer: "",
        creditCode: "",
        cstName: "",
        powerAttorney: "",
        attachment: "",
        attachmentName: ""
      },
      doType: 0,
      loading: null,
      rules: {
        invoiceTitle: [{
          required: true,
          message: this.$t('blExchangeAppointment.invoiceTitleNotNull'),
          trigger: 'blur'
        }],
        paymentMethod: [{
          required: true,
          message: this.$t('blExchangeAppointment.paymentMethodNotNull'),
          trigger: 'blur'
        }],
        paymentNo: [{
          required: true,
          message: this.$t('blExchangeAppointment.paymentNoNotNull'),
          trigger: 'blur'
        }],
        invoiceTaxNo: [{
          required: true,
          message: this.$t('blExchangeAppointment.invoiceTaxNoNotNull'),
          trigger: 'blur'
        }],
        invoiceBankNo: [{
          required: true,
          message: this.$t('blExchangeAppointment.invoiceBankNoNotNull'),
          trigger: 'blur'
        }],
        accountBank: [{
          required: true,
          message: this.$t('blExchangeAppointment.accountBankNotNull'),
          trigger: 'blur'
        }],
        receiveEmail: [{
          required: true,
          message: this.$t('blExchangeAppointment.emailNotNull'),
          trigger: 'blur'
        }, {
          type: 'email',
          message: this.$t('blExchangeAppointment.invalidEmail'),
          trigger: 'blur'
        }, {
          pattern: /^[\w-]+(\.[\w-]+)*@[\w-]+(\.[\w-]+)+$/,
          message: this.$t('blExchangeAppointment.invalidEmail'),
          trigger: 'blur'
        }],
        address: [{
          required: true,
          message: this.$t('blExchangeAppointment.addressNotNull'),
          trigger: 'blur'
        }],
        phone: [{
          required: true,
          validator: function validator(rule, value, callback) {
            if (!value) {
              callback(new Error(_this.$t('blExchangeAppointment.phoneNotNull')));
            }
            var mobile = /^1[3456789]\d{9}$/;
            var tel = /^(\(\d{3,4}\)|\d{3,4}-|\s)?\d{7,14}$/;
            if (mobile.test(value) || tel.test(value)) {
              callback();
            } else {
              callback(new Error(_this.$t('blExchangeAppointment.invalidPhone')));
            }
          },
          trigger: 'blur'
        }],
        attachment: [{
          validator: this.validateAttachment,
          trigger: 'blur'
        }]
      }
    };
  },
  computed: (0, _objectSpread2.default)({}, (0, _vuex.mapGetters)(['language'])),
  methods: {
    validateAttachment: function validateAttachment(rule, value, callback) {
      if (this.form.paymentStatus !== 1 && this.amount > 0 && (0, _validate.validateNull)(value)) {
        callback(new Error(this.$t('blExchangeAppointment.bankSlipNotNull')));
      } else {
        callback();
      }
    },
    handleCancel: function handleCancel() {
      var _this2 = this;
      this.loading = (0, _utils.load)();
      (0, _blExchangeAppointmentSh.cancelDocEdoAccredit)(this.form.edoAccreditId).then(function (res) {
        if (res.success) {
          _this2.closed();
        }
      }).finally(function () {
        _this2.loading.close();
      });
    },
    handleSave: function handleSave() {
      var _this3 = this;
      this.$refs['form'].validate(function (valid) {
        if (valid) {
          _this3.form.blNos = _this3.blNos;
          _this3.form.doType = _this3.doType;
          _this3.loading = (0, _utils.load)();
          if (_this3.form.attachment) {
            _this3.form.attachmentName = _this3.attachmentName;
          } else {
            _this3.form.attachmentName = "";
          }
          (0, _blExchangeAppointmentSh.saveDocEdoAccredit)(_this3.form).then(function (res) {
            if (res.success) {
              _this3.closed();
            } else {
              _this3.$message.warning(res.errorMessages[0]);
            }
          }).finally(function () {
            _this3.loading.close();
          });
        }
      });
    },
    opened: function () {
      var _opened = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee() {
        var _this4 = this;
        var powerAttorney, attachment;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (!this.edoAccreditId) {
                _context.next = 11;
                break;
              }
              this.loading = (0, _utils.load)();
              _context.next = 4;
              return (0, _blExchangeAppointmentSh.getForespeak)(this.edoAccreditId).then(function (res) {
                if (res.success) {
                  _this4.form = res.data;
                }
              }).finally(function () {
                _this4.loading.close();
              });
            case 4:
              this.blNos = [this.form.blNo];
              powerAttorney = this.form.powerAttorney;
              if (powerAttorney) {
                (0, _booking.getFileInfo)(powerAttorney).then(function (res) {
                  if (res.success && res.data) {
                    _this4.powerAttorneyFileList = [{
                      name: res.data.fileName,
                      url: res.data.fileUrl,
                      fileId: res.data.fileId
                    }];
                  }
                });
              }
              attachment = this.form.attachment;
              if (attachment) {
                (0, _booking.getFileInfo)(attachment).then(function (res) {
                  if (res.success && res.data) {
                    _this4.attachmentFileList = [{
                      name: res.data.fileName,
                      url: res.data.fileUrl,
                      fileId: res.data.fileId
                    }];
                  }
                });
              }
              _context.next = 13;
              break;
            case 11:
              this.$set(this.form, 'paymentStatus', this.paymentStatus);
              this.$set(this.form, 'forespeakStatus', this.forespeakStatus);
            case 13:
              if (this.blNos && this.blNos.length > 0) {
                (0, _blExchangeAppointmentSh.getBlNoDoType)(this.blNos[0]).then(function (res) {
                  if (res.success) {
                    if (res.data) {
                      _this4.doType = 1;
                    } else {
                      _this4.doType = 0;
                    }
                  }
                });
              }
            case 14:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function opened() {
        return _opened.apply(this, arguments);
      }
      return opened;
    }(),
    selectSipgCstCodeChange: function selectSipgCstCodeChange(row, data) {
      this.form.sipgCustomer = data.sipgCstCode;
      this.form.creditCode = data.creditCode;
      this.form.cstName = data.cstName;
    },
    closed: function closed() {
      this.$emit('handleCloseReservation');
    },
    uploadPowerAttorneyFile: function uploadPowerAttorneyFile(item) {
      var _this5 = this;
      if (item.file.size > 10 * 1024 * 1024) {
        this.$message.warning(this.$t('blExchangeAppointment.fileSize'));
        this.powerAttorneyFileList = [];
        return;
      }
      var validTypes = ['application/pdf', 'image/jpeg', 'image/png', 'image/bmp', 'image/tiff'];
      if (!validTypes.includes(item.file.type)) {
        this.$message.warning(this.$t('blExchangeAppointment.fileFormat'));
        this.powerAttorneyFileList = [];
        return;
      }
      if (item.file.name.length > 40) {
        this.$message.warning(this.$t('blExchangeAppointment.attachmentFileLength'));
        this.powerAttorneyFileList = [];
        return;
      }
      this.loading = (0, _utils.load)();
      var formDatas = new FormData();
      formDatas.append("file", item.file);
      formDatas.append("bucket", 'commerce');
      (0, _booking.setUploadFile)(formDatas).then(function (res) {
        if (res.code) {
          _this5.form.powerAttorney = res.fileId;
          _this5.attachmentName = res.fileName;
        } else {
          _this5.$message.warning(res.errorMessages[0]);
        }
      }).finally(function () {
        _this5.loading.close();
      });
    },
    handledPowerAttorneyRemove: function handledPowerAttorneyRemove() {
      var _this6 = this;
      (0, _booking.deleteByFileId)(this.form.powerAttorney).then(function (res) {
        if (res == "success") {
          _this6.form.powerAttorney = "";
          _this6.$message.success(_this6.$t('roleCertificationApplication.deleteMessage'));
        } else {
          _this6.$message.warning(res.errorMessages[0]);
        }
      });
    },
    uploadAttachmentFile: function uploadAttachmentFile(item) {
      var _this7 = this;
      if (item.file.size > 10 * 1024 * 1024) {
        this.$message.warning(this.$t('blExchangeAppointment.fileSize'));
        this.attachmentFileList = [];
        return;
      }
      var validTypes = ['application/pdf', 'image/jpeg', 'image/png', 'image/bmp', 'image/tiff'];
      if (!validTypes.includes(item.file.type)) {
        this.$message.warning(this.$t('blExchangeAppointment.fileFormat'));
        this.attachmentFileList = [];
        return;
      }
      if (item.file.name.length > 40) {
        this.$message.warning(this.$t('blExchangeAppointment.attachmentFileLength'));
        this.attachmentFileList = [];
        return;
      }
      this.loading = (0, _utils.load)();
      var formDatas = new FormData();
      formDatas.append("file", item.file);
      formDatas.append("bucket", 'commerce');
      (0, _booking.setUploadFile)(formDatas).then(function (res) {
        if (res.code) {
          _this7.form.attachment = res.fileId;
        } else {
          _this7.$message.warning(res.errorMessages[0]);
        }
      }).finally(function () {
        _this7.loading.close();
      });
    },
    handleAttachmentRemove: function handleAttachmentRemove() {
      var _this8 = this;
      (0, _booking.deleteByFileId)(this.form.attachment).then(function (res) {
        if (res == "success") {
          _this8.form.attachment = "";
          _this8.$message.success(_this8.$t('roleCertificationApplication.deleteMessage'));
        } else {
          _this8.$message.warning(res.errorMessages[0]);
        }
      });
    },
    beforeRemove: function beforeRemove(file) {
      return this.$confirm("\u786E\u5B9A\u79FB\u9664 ".concat(file.name, "\uFF1F"));
    },
    //关闭
    handleClose: function handleClose() {
      this.$emit('update:visible', false);
    },
    //打印
    handlePrint: function handlePrint() {
      this.fullscreenSize = true;
      this.$refs.dragDialog.handleFull();
      setTimeout(function () {
        window.print();
      }, 500);
    },
    //下载委托书
    handleDownloadAttorney: function handleDownloadAttorney() {
      (0, _blExchangeAppointmentSh.downloadDocEdoAccredit)().then(function (res) {
        var url = window.URL.createObjectURL(new Blob([res], {
          type: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
        }));
        var link = document.createElement('a');
        link.style.display = 'none';
        link.href = url;
        link.setAttribute('download', '提货单换单委托书.docx');
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      });
    },
    //发票抬头自动赋值接收邮箱
    getCustomerEmail: function getCustomerEmail() {
      var _this9 = this;
      console.log("getCustomerEmail", this.form.invoiceTitle);
      (0, _blExchangeAppointmentSh.getCustomerEmail)(this.form.invoiceTitle).then(function (res) {
        if (res.success) {
          _this9.form.receiveEmail = res.data.customerEmail;
        } else {
          _this9.$message.error(res.errorMessages[0]);
        }
      });
    }
  }
};